import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from "@air/primitive-input";
import { forwardRef, memo, useCallback, useImperativeHandle, useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
export const PDFSearchInput = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { onSearchChange } = param;
    const inputRef = useRef(null);
    const [value, setValue] = useState("");
    useImperativeHandle(forwardedRef, ()=>({
            setInitialValue: (value)=>{
                setValue(value);
                onSearchChange(value);
            },
            focus: (selectText)=>{
                var _inputRef_current;
                (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus({
                    preventScroll: true
                });
                if (selectText) {
                    var _inputRef_current1;
                    (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.select();
                }
            },
            clear: ()=>{
                var _inputRef_current;
                setValue("");
                (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.blur();
            },
            getIsFocused: ()=>document.activeElement === inputRef.current
        }), [
        onSearchChange
    ]);
    const [onDebouncedSearch] = useDebouncedCallback(onSearchChange, 300, {
        trailing: true
    });
    const onValueChange = useCallback((event)=>{
        const value = event.target.value;
        setValue(value);
        onDebouncedSearch(value);
    }, [
        onDebouncedSearch
    ]);
    return /*#__PURE__*/ _jsx(Input, {
        "data-testid": "PDF_SEARCH_INPUT",
        value: value,
        onChange: onValueChange,
        ref: inputRef,
        className: "flex-1 border-none pl-0 text-16 focus-within:border-none focus-within:shadow-none focus:ring-0",
        placeholder: "Search document"
    });
}));
PDFSearchInput.displayName = "PDFSearchInput";
